var _path, _rect, _path2, _circle, _path3, _path4, _rect2, _path5, _circle2, _circle3, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEgressGatewayinline = function SvgEgressGatewayinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M51 40H32M32 21h7a1 1 0 0 1 1 1v36a1 1 0 0 1-1 1h-7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 24,
    x: 32,
    y: 15,
    fill: "#D6EBFF",
    stroke: "#0073E6",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1,
    transform: "rotate(90 32 15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0073E6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 20h-8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 20,
    r: 1,
    fill: "#0073E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5D6",
    stroke: "#FFBF00",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M32 35v10H8V35z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBF00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 40h-8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 24,
    x: 32,
    y: 55,
    fill: "#D6FFFC",
    stroke: "#00877C",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1,
    transform: "rotate(90 32 55)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00877C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 60h-8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 60,
    r: 0.5,
    fill: "#0073E6",
    stroke: "#00877C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 40,
    r: 1,
    fill: "#FFBF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A7B1BE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M60 40h15.5m0 0-4.23 4m4.23-4-4.23-4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDADA",
    d: "M47 31v15.894C47 48.61 50.581 50 55 50c4.419 0 8-1.39 8-3.106V31"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EB4748",
    strokeWidth: 2,
    d: "M47 31v15.894C47 48.61 50.581 50 55 50c4.419 0 8-1.39 8-3.106V31"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDADA",
    stroke: "#EB4748",
    strokeWidth: 2,
    d: "M55 34c4.418 0 8-1.343 8-3s-3.582-3-8-3-8 1.343-8 3 3.582 3 8 3Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EB4748",
    strokeWidth: 2,
    d: "M63 39c0 1.657-3.582 3-8 3s-8-1.343-8-3"
  })));
};
export default SvgEgressGatewayinline;